import { ReactNode } from 'react';

export interface SnackbarProviderProps {
  children: ReactNode;
}

export interface SnackbarOptions {
  title: string;
  message: string;
  type: SnackbarType;
  timeout?: number;
  action?: ReactNode;
}
export interface SnackbarContextProps {
  showSnackbar: ({ title, message, type }: SnackbarOptions) => void;
}

export enum SnackbarColor {
  danger = 'danger',
  neutral = 'neutral',
  primary = 'primary',
  success = 'success',
  warning = 'warning',
}

export enum SnackbarType {
  info = 'info',
  error = 'error',
  success = 'success',
  warning = 'warning',
}
